/**
 * NotCollected — explicit "this signal has never been collected" label.
 *
 * Spec 216 (FR-007/T020): screens must distinguish a metric that was
 * collected and IS empty (render `—` / 0) from one no collector populates
 * yet (render this label). Bare zeros for uncollected signals are banned —
 * the gap becomes a collection request, never a fake number (FR-018).
 */
import React from 'react';
import clsx from 'clsx';
import { AppTooltip } from './AppTooltip';

export interface NotCollectedProps {
  /** Optional explanation of what would collect this signal */
  reason?: string;
  className?: string;
}

export const NotCollected: React.FC<NotCollectedProps> = ({ reason, className }) => {
  const label = (
    <span
      data-testid="not-collected"
      className={clsx(
        'inline-flex items-center rounded border border-dashed border-[var(--color-border)]',
        'px-1.5 py-0.5 text-xs font-medium italic text-[var(--color-text-secondary)]',
        className
      )}
    >
      not collected
    </span>
  );

  return reason ? <AppTooltip title={reason}>{label}</AppTooltip> : label;
};

export default NotCollected;
